import React, { createContext, useContext } from 'react';

interface ReadOnlyContextType {
  readonly: boolean;
}

const ReadOnlyContext = createContext<ReadOnlyContextType>({ readonly: false });

export const useReadOnly = () => useContext(ReadOnlyContext);

export const ReadOnlyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ReadOnlyContext.Provider value={{ readonly: false }}>
      {children}
    </ReadOnlyContext.Provider>
  );
};
